import React from 'react';
import classnames from 'classnames';

import { StrapiVideoFragment } from '../../../graphql.schema';
import { fullImageUrl } from '../../lib/helpers';

import * as styles from './VideoPlayer.module.scss';

type VideoPlayerProps = {
  className?: string;
  video: StrapiVideoFragment;
  poster?: string;
};

export const VideoPlayer: React.FC<VideoPlayerProps> = (props) => {
  return (
    <video
      className={classnames(styles.root, props.className)}
      controls
      controlsList="nodownload"
      preload="metadata"
      poster={props.poster}
      data-testid="wse-video-player"
    >
      <source src={fullImageUrl(props.video.url)} type={props.video.mime}></source>
    </video>
  );
};
